import { type ReactElement } from 'react';
import { useFiltersAdvancedSearchUrlFactory } from '../../../../jira/jira-advanced-search-url-factory';
import { type AdvancedSearchUrlGenerator } from '../../../product-router/product-router-state';

export const JiraAdvancedSearchProvider = ({
	children,
}: {
	children: (generateAdvancedSearchUrl: AdvancedSearchUrlGenerator) => ReactElement;
}) => {
	const generateAdvancedSearchUrl = useFiltersAdvancedSearchUrlFactory();

	return children(generateAdvancedSearchUrl);
};
